import { render, staticRenderFns } from "./TopicsList.vue?vue&type=template&id=70ba7554&scoped=true&"
import script from "./TopicsList.vue?vue&type=script&lang=js&"
export * from "./TopicsList.vue?vue&type=script&lang=js&"
import style0 from "./TopicsList.vue?vue&type=style&index=0&id=70ba7554&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ba7554",
  null
  
)

export default component.exports